import styled from 'styled-components';
import { Card, Typography } from 'antd';


export const StyledCard = styled(({
  width,
  padding,
  hideShadow,
  ...rest
}) => <Card {...rest} />)`
  && {
    background: ${({ theme }) => theme.currentModeConfig.contentBackground};
    width: ${({ width }) => width};
    box-shadow: ${({ theme, hideShadow }) => (hideShadow ? 'none' : theme.shadow.mildShadow)};
  }
`;
export const StyledSignUpLayoutTitle = styled(Typography.Title).attrs({ level: 4 })`
  && {
    margin-top: 0;
    margin-bottom: 28px;
    line-height: 24px;
    font-weight: 700;
    font-family: Manrope, sans-serif;
  }
`;

export const StyledSignUpLayoutBottomMessage = styled(Typography.Text)`
  font-family: Inter, sans-serif;
  font-weight: 500;
  margin-top: 32px;
`;
